import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const adapter = createEntityAdapter({
    selectId: (x) => x.id,
    sortComparer: (a, b) => a.title.localeCompare(b.title),
});
export const panelsSlice = createSlice({
    name: 'panels',
    initialState: adapter.getInitialState(),
    reducers: {
        panelsCleared(s) { adapter.removeAll(s); },
        panelUpdated(s, a) { adapter.addOne(s, a); },
        panelDeleted(s, a) { adapter.removeOne(s, a); },
        panelReplaced(s, a) { adapter.setAll(s, a); }
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (s, action) => {
            adapter.setAll(s, action.payload.panels);
        });
    }
});
export const { panelsCleared, panelUpdated, panelDeleted, panelReplaced } = panelsSlice.actions;
export const panelAdded = panelUpdated;
export default panelsSlice.reducer;
